import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export function useExtractionCorrected(extractionId: string) {
  const glynt = useGlynt();

  const extractionData = useQuery({
    queryKey: ['extraction', extractionId, { view: 'corrected' }],
    queryFn: async () => await (await glynt).extraction.retrieve_corrected_results(extractionId),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5
  });

  return extractionData;
}
